<template>
  <footer id="main-footer">
    <div class="container">
      <div
        v-if="!$store.getters['user/isLogged'] || $store.getters['user/user'].is_personal_infos_filled"
      >
        <nav class="navbar-menu">
          <div class="row">
            <ul
              class="col-sm-3 text-sm-left text-center mb-md-0 mb-3"
              v-for="(footerMenu, index) in footerMenuSet"
              :key="`footer-${index}`"
            >
              <li
                v-for="link in footerMenu"
                :key="link.text"
              >
                <router-link
                  :to="link.to"
                >{{ link.text }}</router-link>
              </li>
            </ul>
          </div>
        </nav>
        <div class="divisor"></div>
      </div>

      <div class="social-box">
        <div class="row align-items-center">
          <div class="col-lg-7 mb-lg-0 mb-4 d-flex align-items-center justify-content-center justify-content-lg-start">
            <span class="mr-4 d-xl-block d-lg-none d-md-block d-none yellow">#nos encontre</span>
            <div class="social-buttons d-flex">
              <SocialButton
                variant="facebook"
                url="https://www.facebook.com/sitecyberclass"
                class="mr-4"
              />

              <SocialButton
                variant="instagram"
                url="https://www.instagram.com/sitecyberclass"
                class="mr-4"
              />

              <SocialButton
                variant="twitter"
                url="https://www.twitter.com/sitecyberclass"
              />
            </div>
          </div>
          <div class="col-lg-5 text-center text-lg-right">
            <span class="mr-4 d-xl-inline-block d-lg-none d-md-inline-block d-none yellow">pague com</span>
            <img v-lazy="require('@/assets/img/credit-card-brands.png')" class="img-fluid" alt="CyberClass - Cartões Aceitos">
          </div>
        </div>
      </div>
      <div class="divisor"></div>
      <div class="copyright-box">
        <div class="institutional-box">
          <img v-lazy="require('@/assets/img/logo-icone.svg')" alt="CyberClass Logo">
          <div class="pl-2">
            <span class="brand-name">CyberClass &copy; {{ year }}</span>
            <div class="cnpj">CNPJ: 04.617.572/0001-75</div>
          </div>
        </div>
        <a href="//www.petaxxon.com.br" target="_blank">
          <img class="d-none d-sm-inline-block" v-lazy="require('@/assets/img/petaxxon-logo.png')" alt="Petaxxon Logo">
          <img class="d-inline-block d-sm-none" v-lazy="require('@/assets/img/petaxxon-icon-logo.png')" alt="Petaxxon Logo">
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
  import SocialButton from '@/components/buttons/SocialButton'
  import { mapState } from 'vuex'

  export default {
    components: {
      SocialButton,
    },
    computed: {
      ...mapState('menu', ['footerMenuSet']),

      year () {
        return (new Date).getFullYear()
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  #main-footer {
    padding: 2.5rem 0;
    background-color: $darkBgPrimaryColor;
    border-top: 1px solid $highlightPrimaryColor;

    @media (max-width: $tabletBreakpoint) {
      padding: 48px 80px;
    }

    @media (max-width: $mobileBreakpoint) {
      padding: 48px 48px;
    }

    .divisor {
      margin: 1.875rem 0;
      // border-top: 1px solid rgba(#494949, .3);
    }

    .navbar-menu {
      font-size: 16px;
      font-weight: 300;
  
      a {
        display: block;
        padding: 10px 0;
        transition: .5s all;

        // &:hover {
        //   color: $highlightPrimaryColor;
        // }
      }
    }

    .copyright-box {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .institutional-box {
        display: flex;

        .brand-name {
          font-size: 0.9rem;
          font-weight: 700;
        }

        .cnpj {
          font-size: 0.9rem;

          @media (max-width: $mobileBreakpoint) {
            font-size: 0.7rem;
          }
        }
      }
    }

    .yellow {
      color: $highlightPrimaryColor;
    }
  }
</style>